import { Ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

export const useRouteState = (options?: {
  modalVisible?: Ref<boolean>;
  toHome?: () => void;
  toEditor?: () => void;
}) => {
  const route = useRoute();
  const isEditorPage = computed(() => route && route.name == 'editor');
  watch(
    () => route && route.name,
    () => {
      if (options?.modalVisible != undefined)
        options.modalVisible.value = false;

      if (route && route.name == 'home') {
        options?.toHome?.();
      }
      if (route && route.name == 'editor') {
        options?.toEditor?.();
      }
    }
  );
  return {
    isEditorPage
  };
};
